import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import Button from "../../Utilities/Button";
import gsap, { Power2 } from "gsap";

const ProjectItem = ({ img, title, website, description, detail, flip, bullets }) => {
  const navigate = useNavigate();
  const leftRef = useRef();
  const rightRef = useRef();

  useEffect(() => {
    gsap.fromTo(
      rightRef.current,
      {
        x: "50%",
        opacity: 0,
      },
      {
        x: "0%",
        opacity: 1,
        duration: 3.5,
        delay: 0.5,
        ease: Power2.easeOut,
        scrollTrigger: {
          trigger: rightRef.current,
        },
      }
    );
    gsap.fromTo(
      leftRef.current,
      {
        x: "-50%",
        opacity: 0,
      },
      {
        x: "0%",
        duration: 3.5,
        opacity: 1,
        delay: 1.5,
        ease: Power2.easeOut,
        scrollTrigger: {
          trigger: leftRef.current,
        },
      }
    );
  }, []);
  return (
    <div
      className={`flex gap-8 flex-col ${
        flip ? "lg:flex-row-reverse" : "lg:flex-row "
      } `}
    >
      {img ? (
        <img
          src={img}
          alt="project"
          ref={flip ? rightRef : leftRef}
          className="opacity-0 shadow-xl sm:w-3/5 w-11/12 md:w-1/2 rounded-xl"
        />
      ) : (
        <div
          ref={flip ? rightRef : leftRef}
          className="opacity-0 sm:w-3/5 w-11/12 md:w-1/2 rounded-xl bg-N5/50 aspect-[16/10] flex items-center justify-center"
        >
          <span className="text-N40 text-sm">Preview coming soon</span>
        </div>
      )}
      <div className="opacity-0" ref={!flip ? rightRef : leftRef}>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-light mb-2 sm:mb-4 text-N90 capitalize">
          {title}
        </h1>
        {bullets?.length ? (
          <ul className="sm:text-lg 2xl:text-xl 2xl:leading-[1.7] font-light mb-4 sm:mb-8 text-N70 list-disc list-outside pl-5 sm:pl-6 space-y-2">
            {bullets.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        ) : (
          <p className="sm:text-lg 2xl:text-xl 2xl:leading-[1.7] font-light mb-4 sm:mb-8 text-N70">
            {description}
          </p>
        )}
        <div className="flex gap-4 items-center">
          <Button
            variant="primary"
            onClick={() => navigate(detail)}
            custom="py-2"
          >
            view project
          </Button>
          {website && (
            <a href={website} target="_blank" rel="noopener noreferrer">
              <Button variant="outline" custom="py-2">
                view site
              </Button>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
